var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showChart),expression:"showChart"}]},[_c('canvas',{attrs:{"id":"boxplot"}})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showChart),expression:"!showChart"}],staticClass:"mt-10"},[_vm._v("Tidak ada data tersedia")])])
}
var staticRenderFns = []

export { render, staticRenderFns }